/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetComponentKbTypeResponseDto } from './AssetComponentKbTypeResponseDto';
import {
    AssetComponentKbTypeResponseDtoFromJSON,
    AssetComponentKbTypeResponseDtoFromJSONTyped,
    AssetComponentKbTypeResponseDtoToJSON,
    AssetComponentKbTypeResponseDtoToJSONTyped,
} from './AssetComponentKbTypeResponseDto';
import type { AssetComponentCodedLookupResponseDto } from './AssetComponentCodedLookupResponseDto';
import {
    AssetComponentCodedLookupResponseDtoFromJSON,
    AssetComponentCodedLookupResponseDtoFromJSONTyped,
    AssetComponentCodedLookupResponseDtoToJSON,
    AssetComponentCodedLookupResponseDtoToJSONTyped,
} from './AssetComponentCodedLookupResponseDto';

/**
 * 
 * @export
 * @interface AssetComponentContextResponseDto
 */
export interface AssetComponentContextResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetComponentContextResponseDto
     */
    id: string;
    /**
     * 
     * @type {AssetComponentCodedLookupResponseDto}
     * @memberof AssetComponentContextResponseDto
     */
    assetType: AssetComponentCodedLookupResponseDto;
    /**
     * 
     * @type {AssetComponentCodedLookupResponseDto}
     * @memberof AssetComponentContextResponseDto
     */
    subsystem: AssetComponentCodedLookupResponseDto;
    /**
     * 
     * @type {AssetComponentCodedLookupResponseDto}
     * @memberof AssetComponentContextResponseDto
     */
    componentClass: AssetComponentCodedLookupResponseDto;
    /**
     * 
     * @type {AssetComponentKbTypeResponseDto}
     * @memberof AssetComponentContextResponseDto
     */
    componentType: AssetComponentKbTypeResponseDto;
}

/**
 * Check if a given object implements the AssetComponentContextResponseDto interface.
 */
export function instanceOfAssetComponentContextResponseDto(value: object): value is AssetComponentContextResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetType' in value) || value['assetType'] === undefined) return false;
    if (!('subsystem' in value) || value['subsystem'] === undefined) return false;
    if (!('componentClass' in value) || value['componentClass'] === undefined) return false;
    if (!('componentType' in value) || value['componentType'] === undefined) return false;
    return true;
}

export function AssetComponentContextResponseDtoFromJSON(json: any): AssetComponentContextResponseDto {
    return AssetComponentContextResponseDtoFromJSONTyped(json, false);
}

export function AssetComponentContextResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetComponentContextResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetType': AssetComponentCodedLookupResponseDtoFromJSON(json['assetType']),
        'subsystem': AssetComponentCodedLookupResponseDtoFromJSON(json['subsystem']),
        'componentClass': AssetComponentCodedLookupResponseDtoFromJSON(json['componentClass']),
        'componentType': AssetComponentKbTypeResponseDtoFromJSON(json['componentType']),
    };
}

export function AssetComponentContextResponseDtoToJSON(json: any): AssetComponentContextResponseDto {
    return AssetComponentContextResponseDtoToJSONTyped(json, false);
}

export function AssetComponentContextResponseDtoToJSONTyped(value?: AssetComponentContextResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetType': AssetComponentCodedLookupResponseDtoToJSON(value['assetType']),
        'subsystem': AssetComponentCodedLookupResponseDtoToJSON(value['subsystem']),
        'componentClass': AssetComponentCodedLookupResponseDtoToJSON(value['componentClass']),
        'componentType': AssetComponentKbTypeResponseDtoToJSON(value['componentType']),
    };
}

